module.exports = __webpack_public_path__ + "static/media/Maison-Common-Summer-2019-5680.4a2618d7.jpg";